import CardWrapper from '../card-wrapper';
import Step04Image from '../../../../../assets/images/memory/onboarding/step-04.svg';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step04 = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex w-full flex-col items-start justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            <i>Flashcards</i>
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Adicionando um <i>flashcard</i> do Aprova Total
          </Typography>
          <Typography className='flex flex-col gap-4 !text-md !font-normal text-mono-color-darker '>
            <span>
              Os <i>flashcards</i> do Aprova Total aparecem nas videoaulas de
              cada disciplina.
              <br />
              Ao resolvê-los, eles entram automaticamente no{' '}
              <span className='font-bold'>ciclo de revisões dos Flashcards.</span>{' '}
            </span>
            <span>
              Você também encontra <i>flashcards</i> no{' '}
              <span className='font-bold'>Cronograma Personalizado</span> e nos{' '}
              <span className='font-bold'>cursos</span>.
            </span>
          </Typography>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[438px] w-[554px]'>
        <img
          src={Step04Image}
          alt='Step 04'
          className='h-full w-full rounded-lg md:object-cover'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step04;
